import script from "./FailPayment.vue?vue&type=script&setup=true&lang=js"
export * from "./FailPayment.vue?vue&type=script&setup=true&lang=js"

import "./FailPayment.vue?vue&type=style&index=0&id=12bd44b5&scoped=true&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12bd44b5"]])

export default __exports__